import React from 'react';
import { Card, CardContent, styled, SxProps } from '@mui/material';

const StyledStatisticsCard = styled(Card)(() => ({
    height: '120px',
    width: '200px',
    marginRight: '20px',
    border: '2px solid #134C03'
}));

interface CardComponentProps {
    children: JSX.Element;
    cardStyle?: SxProps;
}

export function CardComponent({ children, cardStyle }: CardComponentProps): React.ReactElement {
    return (
        <StyledStatisticsCard variant="outlined" sx={{ ...cardStyle }}>
            <CardContent>{children}</CardContent>
        </StyledStatisticsCard>
    );
}
